module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [(_vm.collapsed) ? _c('el-col', {
    staticClass: "logo",
    class: 'logo-collapse-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.sysNameShort))]) : _vm._e(), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuShow),
      expression: "menuShow"
    }],
    staticClass: "logo",
    class: 'logo-width',
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "headerinfo"
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-left": "52px",
      "width": "113px",
      "height": "64px",
      "margin-top": "20px"
    },
    attrs: {
      "src": this.headerImg
    }
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.titleLogo),
      expression: "titleLogo"
    }],
    staticClass: "jnjhead"
  }, [_vm._v("上海华洋保险经纪")])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    staticStyle: {
      "padding": "7px 10px"
    },
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": "",
      "icon": "el-icon-bell"
    },
    on: {
      "click": _vm.menuShowChange
    }
  }, [_vm._v("折叠/展开")])], 1), _vm._v(" "), _c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('el-tag', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "text",
      "disabled": "true",
      "round": ""
    }
  }, [_vm._v("hi," + _vm._s(_vm.sysUserName) + "!")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.updatePasswordDialog()
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-switch-button",
      "round": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.logOUt()
      }
    }
  }, [_vm._v("退出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('el-aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuShow),
      expression: "menuShow"
    }],
    style: ('width:' + _vm.leftNovWidth)
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "id": "menuClass",
      "router": "",
      "unique-opened": "",
      "default-active": _vm.$route.path,
      "collapse": _vm.collapsed,
      "collapse-transition": true
    }
  }, [_vm._l((_vm.menuList), function(navMenu) {
    return [(navMenu.children && navMenu.children.length > 0) ? _c('el-submenu', {
      key: navMenu.menuId,
      attrs: {
        "index": navMenu.menuUrl
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navMenu.menuIcon,
      staticStyle: {
        "color": "#428bca"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(navMenu.menuName))])]), _vm._v(" "), _vm._l((navMenu.children), function(navMenuSub) {
      return [(navMenuSub.children && navMenuSub.children.length > 0) ? _c('el-submenu', {
        key: navMenuSub.menuId,
        attrs: {
          "index": navMenuSub.menuUrl
        }
      }, [_c('template', {
        slot: "title"
      }, [_c('i', {
        class: navMenuSub.menuIcon,
        staticStyle: {
          "color": "#428bca"
        }
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(navMenuSub.menuName))])]), _vm._v(" "), _vm._l((navMenuSub.children), function(subBottom) {
        return _c('el-menu-item', {
          key: subBottom.menuId,
          attrs: {
            "data": subBottom,
            "index": subBottom.menuUrl,
            "route": subBottom.menuUrl
          },
          on: {
            "click": function($event) {
              return _vm.addTab(subBottom.menuName, subBottom.menuUrl)
            }
          }
        }, [_c('span', {
          attrs: {
            "slot": "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(subBottom.menuName))])])
      })], 2) : (navMenuSub.menuName === '人事通知') ? _c('el-menu-item', {
        key: navMenuSub.menuId,
        ref: "RSTZ",
        refInFor: true,
        attrs: {
          "id": "RSTZ",
          "data": navMenuSub.menuName,
          "index": navMenuSub.menuUrl,
          "route": navMenuSub.menuUrl
        }
      }, [_c('i', {
        class: navMenuSub.menuIcon,
        staticStyle: {
          "color": "#428bca"
        }
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(navMenuSub.menuName))])]) : _c('el-menu-item', {
        key: navMenuSub.menuId,
        attrs: {
          "data": navMenuSub,
          "index": navMenuSub.menuUrl,
          "route": navMenuSub.menuUrl
        },
        on: {
          "click": function($event) {
            return _vm.addTab(navMenuSub.menuName, navMenuSub.menuUrl)
          }
        }
      }, [_c('i', {
        class: navMenuSub.menuIcon,
        staticStyle: {
          "color": "#428bca"
        }
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(navMenuSub.menuName))])])]
    })], 2) : _c('el-menu-item', {
      key: navMenu.menuId,
      attrs: {
        "data": navMenu,
        "index": navMenu.menuUrl,
        "route": navMenu.menuUrl
      }
    }, [_c('i', {
      class: navMenu.menuIcon,
      staticStyle: {
        "color": "#428bca"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(navMenu.menuName))])])]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container",
    staticStyle: {
      "padding": "0 10px",
      "box-sizing": "border-box"
    },
    style: ({
      width: _vm.sessionWidth
    })
  }, [_c('el-tabs', {
    style: ({
      width: _vm.sessionWidth
    }),
    attrs: {
      "type": "card",
      "closable": ""
    },
    on: {
      "tab-remove": _vm.removeTab,
      "tab-click": function($event) {
        return _vm.addNewtap(_vm.menuTabsValue)
      }
    },
    model: {
      value: (_vm.menuTabsValue),
      callback: function($$v) {
        _vm.menuTabsValue = $$v
      },
      expression: "menuTabsValue"
    }
  }, [_vm._l((_vm.menuTabs), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    })
  }), _vm._v(" "), _c('el-tab-pane', {
    key: "全部关闭",
    attrs: {
      "label": "全部关闭",
      "name": "全部关闭"
    }
  })], 2), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.keepArrary
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('update-user-password', {
    attrs: {
      "visible": _vm.updatePassword.visible,
      "user-code": _vm.updatePassword.sysUserCode
    },
    on: {
      "close": _vm.closeDialog
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae77f68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 384
// module chunks = 55